import qs from 'qs'
export const getQueryParams = (search = window.location.search) => {
  if (!search) {
    return {}
  }
  const newQuerys = search.replace('?', '')
  if (newQuerys === '') {
    return {}
  }
  return qs.parse(newQuerys)

}

export function parseCommaString(value?: string) {
  if (!value) return [];
  return value
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);
}
export function parseCommaNumber(value: string | undefined): number[] {
  if (!value) return [];
  return value
    .split(",")
    .map((v) => Number(v))
    .filter((v) => !Number.isNaN(v));
}

export function buildSearch(params: Record<string, string | undefined>) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== "") {
      searchParams.set(key, value);
    }
  });

  return `?${searchParams.toString()}`;
}